import { render } from "./BarPiece.vue?vue&type=template&id=22560e95&scoped=true"
import script from "./BarPiece.vue?vue&type=script&lang=js"
export * from "./BarPiece.vue?vue&type=script&lang=js"

import "./BarPiece.vue?vue&type=style&index=0&id=22560e95&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22560e95"

export default script